import { Options } from "react-lottie";

export const LOTTIE_DEFAULT_OPTIONS: Options = {
    loop: true,
    autoplay: true,
    animationData: null,
    rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
    }
};